import React from 'react';
export var Play = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "9", height: "12", viewBox: "0 0 9 12", fill: "none", color: color },
        React.createElement("path", { d: "M8.07 6.97a1.2 1.2 0 0 0 0-1.938L2.758 1.157a1.2 1.2 0 0 0-1.907.97v7.75a1.2 1.2 0 0 0 1.907.969L8.071 6.97Z", fill: "currentColor" })));
};
